import { FC, ReactNode, HTMLAttributes } from 'react';
import { BadgeWrapper } from './styles';

export type BadgeColor = 'brand' | 'brand-inverse' | 'am' | 'dm' | 'pm' | 'dvs' | 'guidance-primary';

export type BadgeSize = 'sm' | 'md' | 'lg';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  color?: BadgeColor;
  size?:
    | BadgeSize
    | { base: BadgeSize; tablet?: BadgeSize; desktop?: BadgeSize };
  children: ReactNode;
}

const Badge: FC<BadgeProps> = ({
  color = 'guidance-primary',
  size = { base: 'sm', desktop: 'md' },
  children,
  ...rest
}) => {
  const base = typeof size === 'string' ? size : size.base;
  const tablet = typeof size === 'string' ? undefined : size.tablet;
  const desktop = typeof size === 'string' ? undefined : size.desktop;

  return (
    <BadgeWrapper
      $color={color}
      $sizeBase={base}
      $sizeTablet={tablet}
      $sizeDesktop={desktop}
      {...rest}
    >
      {children}
    </BadgeWrapper>
  );
};

export default Badge;

/**
 * HOW TO IMPLEMENT - BADGE
 * ---------------
 *
 * @example Responsive size (changes at breakpoints)
 * ```tsx
 * <Badge color="am" size={{ base: 'sm', tablet: 'md', desktop: 'lg' }}>
 *   Best Seller
 * </Badge>
 * ```
 *
 * @example With an SVG icon and fixed size
 * ```tsx
 * <Badge color="am" size="lg">
 *   <StarIcon /> Top Rated
 * </Badge>
 * ```
 *
 * @example Minimal (uses defaults: color="guidance-primary", size={ base: 'sm', desktop: 'md' })
 * ```tsx
 * <Badge>Default</Badge>
 * ```
 */
